import script from "./ProductAttributeOptionComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductAttributeOptionComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ProductAttributeOptionComponent.vue?vue&type=style&index=0&id=200d3d92&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200d3d92"]])

export default __exports__